import React, {useEffect, useState} from "react";
import * as Yup from "yup";
import ValidateMessages from "../../../../core/models/static/texts/vallidate-messages";
import useIsMounted from "../../../hooks/use-is-mounted";
import {makeRequired, makeValidate} from "mui-rff";
import classnames from "classnames";
import Form from "../../base/form";
import {Fade, SvgIcon} from "@mui/material";
import IconButton from "../../base/button/icon_button";
import {Edit} from "@mui/icons-material";
import {ReactComponent as RemoveIcon} from "../../../../assets/images/remove.svg";
import {ReactComponent as HorizontalDragIcon} from "../../../../assets/images/notifications/horizontal-drag.svg";
import {OutlinedInputForm} from "../../base/input/outlined_input";
import SaveOrRollback from "../save-or-rollback";


const schema = Yup.object().shape({
    title: Yup.string().nullable().required(ValidateMessages.required)
});

const subscription = {submitting: true, values: true, initialValues: true, submitErrors: true};


const TaskStatusCard = ({
                            status,
                            update,
                            remove,
                            setEditing,
                            sortable,
                            removable = true,
                        }) => {
    const [initialValues, setInitialValues] = useState({});
    const isMounted = useIsMounted()
    const validate = makeValidate(schema);
    const required = makeRequired(schema);

    const editing = status?.inEditMode;

    /**
     * Listens to the changes in the category and with each change:
     * sets the initialValues of the form.
     */
    useEffect(() => {
        setInitialValues({
            title: status?.title ?? '',
        })
    }, [status])

    /**
     * Prepares the new version of the category to be sent through api and then based on the returned resultFlag,
     * remains in or gets out of the edit mode.
     * @param {mode} values formValues
     */
    const updateStatus = (values) => {
        if (values?.title === status?.title) {
            setEditing(false)
            return
        }
        const newTitle = {
            ...status,
            title: values.title,
        }
        update(newTitle).then(resultFlag => resultFlag && isMounted() && setEditing(false))
    }

    /**
     * Reverts the values of this template.
     * @param {any} values
     * @param {formApi} form
     */
    const revertValues = (values, form) => {
        setEditing(false)
        form.reset(initialValues)
    }

    /**
     * Gets users confirmation before removing the current entity.
     */
    const getRemoveConfirmation = () => {
        window.partner?.openConfirmationDialog(
            <div className={'p-3'}>
                <p className={'text-sm text-color-2'}>
                    Do you want to delete this status?
                </p>
            </div>,
            {
                maxWidth: 'sm'
            },
            (confirmed) => confirmed && remove(status).then(),
        );
    }

    return (
        <>
            <div className={classnames('category-notification-card', {'editing': editing})}>
                <Form
                    className={''}
                    onSubmit={() => false}
                    subscription={subscription}
                    validate={validate}
                    initialValues={initialValues}
                    render={({values, form}) => {
                        return (
                            <>
                                <div className={'d-flex flex-column'}>
                                    <div className={classnames('fade-container', {
                                        'expanded': editing,
                                    })}>
                                        <Fade in={editing}
                                              className={'d-flex justify-content-between align-items-center'}>
                                            <div>
                                                <OutlinedInputForm
                                                    name={'title'}
                                                    placeholder={'title'}
                                                    label={"Title"}
                                                    multiline
                                                    className={'mr-2 ml-5 max-w-80'}
                                                    required={required.title}
                                                    value={values.title ?? ''}
                                                    onChange={(e) => form.change(e.target.name, e.target.value)}
                                                />
                                                <SaveOrRollback
                                                    column={false}
                                                    loading={status.editing}
                                                    show={true}
                                                    onRollback={() => revertValues(values, form)}
                                                    onSave={() => updateStatus(values)}
                                                />
                                            </div>
                                        </Fade>
                                        <Fade in={!editing}
                                              className={'d-flex align-items-center justify-content-between'}>
                                            <div>
                                                <p className={'title flex-grow-1'}>
                                                    <Fade in={sortable} className={'mr-3 handle'}>
                                                        <SvgIcon component={HorizontalDragIcon}/>
                                                    </Fade>
                                                    {status?.title ?? ''}
                                                </p>
                                                <div className={'d-flex justify-content-end align-items-center'}>
                                                    <IconButton
                                                        disabled={status.editing || editing}
                                                        className={"mx-1 ml-2"}
                                                        color={'paper.secondary'}
                                                        onPressed={() => setEditing(true)}
                                                    >
                                                        <Edit className={"icon normal"}/>
                                                    </IconButton>
                                                    {
                                                        removable &&
                                                        <IconButton
                                                            onPressed={getRemoveConfirmation}
                                                            disabled={status?.editing}
                                                            color={'paper.error'}
                                                            className={'ml-2'}
                                                        >
                                                            <SvgIcon component={RemoveIcon}
                                                                     className='icon normal'/>
                                                        </IconButton>
                                                    }
                                                </div>
                                            </div>
                                        </Fade>
                                    </div>
                                </div>
                            </>
                        );
                    }}
                />
            </div>
        </>
    );
}

export default TaskStatusCard;
